import React from 'react';
import SvgRobot from '@icons/ai-robot.svg?react';
import SvgAiMagic from '@icons/ai-magic.svg?react';
import { StatusEnum } from '@api/ringil-api.v2.tsx';
import clsx from 'clsx';
import {
  getBorderAndBackgroundClassForInvoiceState,
  stateIcons,
  stateTextColors,
} from '@components/ai/invoiceStateUtils.ts';

export type AiButtonProps = {
  state: StatusEnum;
};

export const AiFileButton: React.FC<AiButtonProps> = ({
                                                           state,
                                                      }) => {

  function isAiMagicVisible(state: StatusEnum) {
    switch (state) {
      case StatusEnum.NEW:
      case StatusEnum.UNKNOWN:
      case StatusEnum.PROCESSING:
      case StatusEnum.SKIPPED_DUE_TO_OTHER_DOCUMENT:
        return false;
      default:
        return true;
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div
        className={clsx(
          'w-fit flex h-[29px] px-2 justify-center items-center gap-2 rounded-lg border border-solid relative cursor-auto',
          getBorderAndBackgroundClassForInvoiceState(state),
        )}
      >
        <SvgRobot className="w-6 h-6" />
        {React.createElement(stateIcons[state], { width: 16, height: 16, className: stateTextColors[state] })}
        {isAiMagicVisible(state) && <SvgAiMagic className="w-5 h-5 text-content-brand" />}
      </div>
    </div>
  );
};